/**
 * Fixed Header is problematic for accessibility.
 * Unfixed header if...
 * user tabs
 * font size is zoomed
 * window is zoomed
 * @module header
 */

import $ from 'jquery';
import breaky from 'breaky';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
export const PLUGIN_NAME = 'fixedHeader';
export const DEFAULTS = {
 fixedClass: 'is-fixed',
 pageContent: '.page',
 tablet: false,
 ab1017: false
};
import mergeOptions from '../lib/merge-options';
import throttle from 'lodash/throttle';

/**
 * Scroll Site's Fixed Header
 * @param  {jQuery} $el - header element
 */

const fixHeaderScroll = ($el) => {
  if($el.hasClass('is-fixed-scroll')) {
    let lastScrollTop = 0;
    let headerPosition = 0;
    const $headerHeight = $el.outerHeight(true);
    $(window).scroll(function(event) {
      if(!$('#tr-mybag').hasClass('dd-is-open')){
        const st = $(this).scrollTop();
        let top = st * - 1;
        const scrollDiff = $headerHeight;
        const diffPosition = top - lastScrollTop;
        headerPosition = headerPosition + diffPosition;
        // detect scrolling direction
        if (headerPosition < -scrollDiff && diffPosition < 0) {
          // scrolling down
          headerPosition = -scrollDiff;
        } else if(headerPosition > 0) {
          // scrolling up
          headerPosition = 0;
        }
        // Conditional below is to fix a bug on Safari
        if (top > 0) {
          headerPosition = 0;
        }
        lastScrollTop = top;

        return $el.css({'transform': 'translate3d(0px, '+headerPosition+ 'px, 0px)'});
      }
    });
  }
};
const checkOverride = ($el, opts) => {
  let fixedClass = opts.fixedClass;
  if ($el.hasClass('override-header')) {
    $el.removeClass(opts.fixedClass);
      fixedClass = 'is-fixed-scroll';
  }
  return fixedClass;
}
/**
 * Add margin at the top of the page content when header is fixed
 * to account for the height of the fixed header and any banners
 * @param  {jQuery} $el - header element
 */
 const addPageContentMargin = ($el, opts) => {
  const { ab1017 } = opts;
   const topHalfHeader = ab1017 ? 0 : 33;
   const topMargin = $el.outerHeight(true) + topHalfHeader;
   $(opts.pageContent).css("margin-top", topMargin);
 }
 /**
  * Remove margin at the top of the page content when header is unfixed
  * @param  {jQuery} $el - header element
  */
  const removePageContentMargin = ($el, opts) => {
    $(opts.pageContent).css("margin-top", 0);
  }
/**
 * Fix Site's Header
 * @param  {jQuery} $el - header element
 */
const fixHeader = ($el, opts) => {
  const { ab1017 } = opts;
  const fixedClass = checkOverride($el, opts);
  $el.addClass(fixedClass);
  if(!opts.tablet) {
      if(!ab1017) {
        $el.addClass('u-margin-b--xl');
      }
    // $el.addClass('u-padding-t--lg');
  }
  $el.trigger("fixedHeader.fixed");
  if(breaky.value != "tablet") {
    addPageContentMargin($el, opts);
  } else {
    $el.removeClass('u-margin-tb--xl');
  }
};

/**
 * Unfix Site's Header
 * @param  {jQuery} $el - header element
 */
const unFixHeader = ($el, opts) => {
  const fixedClass = checkOverride($el, opts);
  $el.removeClass(fixedClass);
  $el.removeClass('u-margin-b--xl');
  $el.removeClass('u-padding-t--lg');
  if (breaky.value === 'tablet') {
    $el.addClass('u-margin-tb--xl');
  }
  $el.trigger("fixedHeader.static");
  removePageContentMargin($el, opts);

};
/**
 * Get original font size of body
 * @param  {jQuery} $body - body element
 */
const getFontSize = ($body) => {
  const currentStyle = $body.attr('style');
  $body.removeAttr('style');
  const fontSize = Number($body.css('font-size').replace('px', ''));
  $body.attr('style', currentStyle);
  return fontSize;
}
/**

 * Check if font is zoomed
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $window - window element
 * @param  {jQuery} $body - header element
 */
const fontZoomCheck = ($el, $window, $body, opts) => {
  const fixedClass = checkOverride($el, opts);
  if($el.hasClass(fixedClass)) {
    const actualFontSize = Number($window[0]
    .getComputedStyle(document.body)
    .getPropertyValue('font-size')
    .replace('px', ''));
    // 110% of base font size
    const threshold = 1.1;
    const baseFontSize = getFontSize($body); ;
    if(actualFontSize > baseFontSize * threshold) {
      unFixHeader($el, opts);
    }
  }
};
/**
 * Fixed Header Toggle Base on Scroll
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $html - html element
 * @param  {jQuery} $window - window element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
const fixedHeaderToggle = ($el, $html, $window, bannerOffset, opts) => {
  const fixedClass = checkOverride($el, opts);

  const { ab1017 } = opts;
  const noFocus = $html.hasClass('no-focus');
  const isFixed = $el.hasClass(fixedClass);
  const topHalfHeader = 33;
  const windowScrollTop = $window.scrollTop();
  const headerOffset = ab1017 ? bannerOffset.header : bannerOffset.header + topHalfHeader;

  if (windowScrollTop > headerOffset && !isFixed && noFocus) {
      fixHeader($el, opts);
      fixHeaderScroll($el, opts);
  } else if (windowScrollTop < headerOffset && isFixed) {
      unFixHeader($el, opts);
  }
  if (ab1017) {
    const throttleBuffer = 150;
    const throttleOffset = headerOffset + throttleBuffer;
    const isThrottled = $el.data('scrollThrottled');
    const rebind = $el.data('rebindScroll');
    if (rebind) {
      if (windowScrollTop > throttleOffset && !isThrottled) {
        rebind(true);
        $el.data('scrollThrottled', true);
      } else if (windowScrollTop <= throttleOffset && isThrottled) {
        rebind(false);
        $el.data('scrollThrottled', false);
      }
    }
  }
};

/**
 * Resize Logo Based on Scroll Position ab1017
 * @param  {jQuery}     $el          - header element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
const resizeLogo = ($el, bannerOffset) => {
  const $icon = $el.find('.branding__logo');
  const headerOffset = bannerOffset.header;
  const iconFullWidth = 217;
  const iconMinWidth = 186;
  const iconWidthDiff = iconFullWidth - iconMinWidth;

  if (scrollY > headerOffset) {
    $icon.css('width', iconMinWidth + 'px');
    return;
  }
  $icon.css('width', (iconFullWidth - (scrollY / headerOffset) * iconWidthDiff) + 'px');
};

/**
 * Scroll Handler
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $html - html element
 * @param  {jQuery} $window - window element
 * @param  {jQuery} $body - header element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
const positionHandler = ($el, $html, $window, $body, bannerOffset, opts) => {
  /* Only fix the header if the window has enough scroll to get past the header */
  const minimumScrollHeight = $(document).height() - $(window).height() - $(document).scrollTop();
  const headerHeight = $el.height();
  if(minimumScrollHeight > headerHeight) {
    fixedHeaderToggle($el, $html, $window, bannerOffset, opts);
    fontZoomCheck($el, $window, $body, opts);
  }
};
/**
 * Tab Event
 * @param  {jQuery} $el - header element
 * @param  {event} evt - key event
 */
const tabEventHandler = ($el, evt, opts) => {
  if (Keyboard.parseKey(evt) === 'TAB'
  || Keyboard.parseKey(evt) === 'SHIFT_TAB') {
    unFixHeader($el, opts);
  }
};
/**
 * Set Event Listeners
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $html - html element
 * @param  {jQuery} $window - window element
 * @param  {jQuery} $body - window element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
const setEventListeners = ($el, $html, $window, $body, bannerOffset, opts) => {
  $html.on('mousedown.fixedHeader', () => fixedHeaderToggle($el, $html, $window, bannerOffset, opts));
  $html.on('keyup.fixedHeader', evt => tabEventHandler($el, evt, opts));

  if (opts.ab1017) {
    const scrollHandler = () => positionHandler($el, $html, $window, $body, bannerOffset, opts);
    const throttledScrollHandlerFixed = throttle(scrollHandler, 100);
    const throttledScrollHandler = throttle(scrollHandler, 10);
    $window.on('scroll.fixedHeader', scrollHandler);
    $el.data('rebindScroll', (fixed) => {
      $window.off('scroll.fixedHeader');
      $window.on('scroll.fixedHeader', fixed ? throttledScrollHandlerFixed : throttledScrollHandler);
    });
    let ticking = false;
    $window.on('scroll.resizeLogo', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          resizeLogo($el, bannerOffset);
          ticking = false;
        });
        ticking = true;
      }
    });
  } else {
    $window.on('scroll.fixedHeader', throttle(evt => positionHandler($el, $html, $window, $body, bannerOffset, opts), 100));
  }
};
/**
 * Get if there's a global banner and return offset value
 * @param  {jQuery} $el - header element
 * @return {pixelValue} Immutable version of the options
 */
const getHeaderOffset = ($el) => {
  return $el.offset().top === 0 ? 1 : $el.offset().top;
};

/**
 * @param  {jQuery} $el - header element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const appendFixScroll = ($el, options = {}) => {

};

/**
 * Initializes Header.
 * @param {HTMLElement} el - header element
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function fixedHeader(el, options = {}) {
  const $el = $(el);
  const $html = $('html');
  const $window = $(window);
  const $body = $('body');
  const bannerOffset = { header: getHeaderOffset($el) };

  // cookie banner disclaimer
  $("#cookiesBar").on('closeCookieBanner', evt => {
      bannerOffset.header = getHeaderOffset($el);
  });

  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, $html, $window, $body, bannerOffset, opts);
  positionHandler($el, $html, $window, $body, bannerOffset, opts);
}
registerJQueryPlugin(PLUGIN_NAME, fixedHeader);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-header.js